// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateProductTag_cancelButton__2yCOZ"};